import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { Contrato } from '../modelo/contrato';

declare var $: any;

@Component({
  selector: 'app-liquidacao-modal-detalhes',
  templateUrl: './liquidacao-modal-detalhes.component.html',
  styleUrls: ['./liquidacao.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class LiquidacaoModalDetalhesComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;

  constructor(
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,
    private mensagemService: MensagemService,
    private router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LiquidacaoModalDetalhesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    this.contrato = this.data.contrato;
  }

  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-liquidacao-cli/liquidacao-modal-detalhes.component.ts